/**
 * 工作流可选节点：与智能工具导航（aiTools）一致，navId 用于跳转与流水线识别。
 */
import { NAV_HUBS, TOOL_NAV_ITEMS, WORKBENCH_TOOL_PATH_BY_NAV } from './workbenchNavConfig';
import {
  isVideoToolsConfigLocked,
  isVideoWorkflowNavId,
} from './videoToolsMaintenance';

/** 工作流画布中不展示的 navId（工作台页面 ≠ 流水线算子） */
const WORKFLOW_EXCLUDED_NAV_IDS = new Set([
  'imageCollection', // POD工具：素材采集
  'thirdPartyReceive', // POD刊登：开放接口推送任务，非流水线节点
  'platformListingJobs', // POD刊登：刊登任务队列页；画布算子是「本地商品库」platformListing
  'platformScheduledListings', // POD刊登：定时上架由「本地商品库」节点上的自动规则决定，不单独建节点
  'sourcingHub', // 插件采集：不再作为画布节点（素材由采集批次/工作台入口导入）
  'titles', // 工作流扩展：标题提取
]);

function toStep(navId) {
  if (WORKFLOW_EXCLUDED_NAV_IDS.has(navId)) return null;
  // 视频工具维护中：步骤库不展示图生/文生视频，禁止新增配置
  if (isVideoToolsConfigLocked() && isVideoWorkflowNavId(navId)) return null;
  const meta = TOOL_NAV_ITEMS[navId];
  if (!meta) return null;
  return {
    navId: meta.id,
    get label() {
      return meta.label;
    },
  };
}

/** 画布左侧分组（与智能工具各分区一致） */
export const IPE_WORKFLOW_PALETTE_SECTIONS = [
  ...NAV_HUBS.aiTools.sections.map((section) => ({
    sectionKey: section.titleKey,
    get title() {
      return section.title;
    },
    items: section.items.map(toStep).filter(Boolean),
  })),
].filter((section) => section.items.length > 0);

/** 扁平列表（兼容旧引用：存储、官方模板编辑等） */
export const IPE_WORKFLOW_STEP_CATALOG = (() => {
  const byId = new Map();
  IPE_WORKFLOW_PALETTE_SECTIONS.forEach((section) => {
    section.items.forEach((item) => {
      if (!byId.has(item.navId)) byId.set(item.navId, item);
    });
  });
  return [...byId.values()];
})();

/**
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {{ name?: string, steps: Array<{ navId: string, label: string }> }} template
 */
export function navigateIpeWorkflowFirstStep(navigate, template) {
  const steps = template?.steps;
  if (!Array.isArray(steps) || steps.length === 0) return;

  const chainDisplay = steps.map((s) => s.label || s.navId).filter(Boolean).join(' → ');
  const first = steps[0];
  const remainingSteps = steps.slice(1).map((s) => ({ navId: s.navId, label: s.label }));

  const hint = {
    templateName: template.name || '未命名模板',
    chainDisplay,
    currentStepLabel: first.label,
    remainingSteps,
    currentStepParams: first.params && typeof first.params === 'object' ? first.params : {},
    allSteps: steps.map((s) => ({
      navId: s.navId,
      label: s.label,
      params: s.params && typeof s.params === 'object' ? s.params : {},
    })),
  };

  const path = WORKBENCH_TOOL_PATH_BY_NAV[first.navId];
  if (path) {
    navigate(path, { state: { ipeWorkflowHint: hint } });
    return;
  }

  navigate('/ipe', {
    state: { activeNav: first.navId, ipeWorkflowHint: hint },
  });
}
